export * from './generated/supported-regions.bk';
